import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { MdEmail } from "react-icons/md";
import { auth } from "../firebase/firebaseConfig";
import { sendPasswordResetEmail } from "firebase/auth";
import { toast } from "react-toastify";
import { appPrimaryColor } from "../utils/constants";
import InnerLoader from "../components/microComponents/InnerLoader";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await sendPasswordResetEmail(auth, email);
            toast.success("Password reset email sent successfully!");
            setEmail("");
        } catch (error) {
            console.error("Error sending reset email:", error);
            toast.error(
                "Failed to send reset email. Please check your email and try again."
            );
        } finally {
            setLoading(false);
            navigate("/login");
        }
    };

    return (
        <div className="min-h-screen flex flex-col md:flex-row">
            {/* Left Side - Background Image */}
            <div className="hidden md:flex md:w-1/2 bg-darkGreen items-center justify-center p-12">
                <div className="max-w-md text-white">
                    <h1 className="text-4xl font-bold mb-6">Reset Password</h1>
                    <p className="text-lg opacity-90">
                        Enter your email address and we'll send you an email to reset your password.
                    </p>
                </div>
            </div>

            {/* Right Side - Form */}
            <div className="flex-1 flex items-center justify-center p-6 bg-gray-50">
                <div className="w-full max-w-md space-y-8 bg-white p-8 rounded-2xl shadow-lg">
                    {/* Header */}
                    <div className="text-center">
                        <h2 className="text-3xl font-bold text-gray-900">Forgot Password</h2>
                        <p className="mt-2 text-sm text-gray-600">
                            Remember your password?{" "}
                            <Link to="/login" className="text-darkGreen hover:underline font-medium">
                                Sign in
                            </Link>
                        </p>
                    </div>

                    {/* Form */}
                    <form onSubmit={handleSubmit} className="space-y-6">
                        {/* Email Field */}
                        <div>
                            <label className="block text-sm font-medium text-gray-700 mb-2">
                                Email Address
                            </label>
                            <div className="relative">
                                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                                    <MdEmail className="h-5 w-5 text-gray-400" />
                                </div>
                                <input
                                    type="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    className="block w-full pl-10 pr-3 py-2.5 text-gray-900 rounded-lg border border-gray-300 
                            focus:ring-2 focus:ring-darkGreen focus:border-transparent"
                                    placeholder="Enter your email"
                                    required
                                />
                            </div>
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={loading}
                            className={`w-full flex justify-center items-center gap-2 py-3 px-4 rounded-lg text-white font-medium transition-all
              ${loading ? 'bg-gray-400 cursor-not-allowed' : `${appPrimaryColor} hover:opacity-90`}`}
                        >
                            {loading ? (
                                <>
                                    <InnerLoader
                                        divSize={{ width: "20px", height: "20px" }}
                                        loaderSize={{ width: "20px", height: "20px" }}
                                    />
                                    <span>Sending Reset Link...</span>
                                </>
                            ) : (
                                'Send Reset Link'
                            )}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPassword; 